<template v-cloak>
    <!--会員登録・更新用パーツ-->
    <div class="pt406" id="pt406">
        <!--パンくずリスト-->
        <breadcrumb v-if="pageType == PAGE_INSERT" :navListCustom="[{title:'新規会員登録', routerName: SiteConstants.PG010MAIN, param: {pageNo: '8'}}, {title:$t('common.labels.inputCheck'), routerName: '', param: {}}]"></breadcrumb>
        <breadcrumb v-if="pageType == PAGE_UPDATE" :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('common.labels.confirmRegistInfor'), routerName: SiteConstants.PG010MAIN, param: {pageNo: '8'}}, {title:$t('common.labels.inputCheck'), routerName: '', param: {}}]"></breadcrumb>

        <div class="">
            <!--画面タイトル-->
            <div class="itemTitle">
                <h2 v-if="pageType == PAGE_INSERT">{{$t('common.labels.memberRegistration')}}</h2>
                <h2 v-if="pageType == PAGE_UPDATE">{{$t('common.labels.myPgage')}}</h2>
            </div>
            <div class="inputCondition">
                <!--見出し-->
                <div class="insertTitle">
                    <h3>{{$t('common.labels.inputCheck')}}</h3>
                </div>
                <!--エラーメッセージ表示-->
                <div class="errorMessage">
                    <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT406_PART"/>
                </div>

                <template v-if="isErrorFlg == 0">

                <!--メッセージ表示-->
                <div class="message" v-if="report != ''">
                    <span>{{report}} </span>
                </div>

                <template>
                    <div class="customer">
                        <!-- 営業許可番号 ユニコカスタマイズ項目 -->
                        <div class="eigyokyoLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="eigyokyoNo_lbl">
                                    <span>{{$t('pt400.labels.eigyokyoNo')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="eigyokyoNo" class="eigyokyoNo">{{pt406Request.unicoEigyokyoNo}}</span>
                            </div>
                        </div>
                        <!--会員ID -->
                        <div class="kaiinIdLine" v-if="pt406Init.kokyakuCdHatuFlg == 1">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="kaiinId_lbl">
                                    <span>{{$t('pt400.labels.kaiinId')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="kaiinId" class="kaiinId">{{pt406Request.kokyakuCd}}</span>
                            </div>
                        </div>
                        <!--メールアドレス-->
                        <div class="mailLine" v-if="!(pt406Init.entetsuFlg == 1 && (pageType == PAGE_INSERT || pageType == PAGE_UPDATE))">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                    <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                </label>
                            </div>
                            <div class="input" >                                    
                                <span id="mail" class="mail">{{pt406Request.mail}}</span>
                            </div>
                        </div>
                        <div class="mailLine" v-if="pt406Init.entetsuFlg == 1 && (pageType == PAGE_INSERT || pageType == PAGE_UPDATE)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                    <span id="mail_lbl">{{$t('common.labels.mailAddress')}}</span>
                                </label>
                            </div>
                            <div class="input" >
                                <span id="mail" class="mail">{{pt406Request.mail}}</span>
                                <span id="mailOld" class="mailOld">{{pt406Request.mailOld}}</span>
                            </div>
                            <div class="input" >
                                <span id="mailOld" class="mailOld">{{pt406Request.mail_confirm}}</span>
                            </div>
                        </div>
                        <template v-if="pt406Init.entetsuFlg != 1 || (pt406Init.entetsuFlg == 1 && pt406Init.entetsuKohojinFlg == 0) ">
                            <!--パスワード-->
                            <div class="PassLine" v-if="pt406Init.passChangeOption == 0 && pt406Init.syouninOption == 0 || pt406Init.passChangeOption == 0 && pt406Init.syouninOption == 1 && pageType == PAGE_UPDATE  || pt406Init.passChangeOption == 1 && pt406Init.syouninOption == 0 && pageType == PAGE_INSERT">
                                <div class="label">
                                    <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'">
                                        <span id="password_lbl">{{$t('pt400.labels.newPass')}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span id="password" class="password">{{passwordView}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- 知ったきっかけ ユニコカスタマイズ項目 -->
                        <div class="cognitionLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="cognitionSelect_lbl">
                                    <span>{{$t('pt400.labels.cognition')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="cognitionSelect" class="cognitionSelect">{{pt406Request.analysisNm09}}</span>
                            </div>
                        </div>
                        <!-- 知ったきっかけ詳細 ユニコカスタマイズ項目 -->
                        <template v-if="unicoCusFlg = 1">
                            <div class="cognitionLineDtl cognitionLineDtl1" v-if="pt406Request.yobiStr2">
                                <div class="label">
                                    <label class="optional" id="cognitionLineDtl1_lbl">
                                        <span>{{$t('pt400.labels.cognition')}}（{{pt406Request.yobiStr2}}）</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span id="cognitionLineDtlValue1" class="cognitionLineDtlValue1">{{pt406Request.unicoCognitionDtlValue1}}</span>
                                </div>
                            </div>
                            <div class="cognitionLineDtl cognitionLineDtl2" v-if="pt406Request.yobiStr4">
                                <div class="label">
                                    <label class="optional" id="cognitionLineDtl2_lbl">
                                        <span>{{$t('pt400.labels.cognition')}}（{{pt406Request.yobiStr4}}）</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <span id="cognitionLineDtlValue2" class="cognitionLineDtlValue2">{{pt406Request.unicoCognitionDtlValue2}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- 業種 ユニコカスタマイズ項目 -->
                        <div class="gyosyuLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label :class="pageType == PAGE_INSERT?'required':'verticalAlignTop'" id="gyosyuSelect_lbl">
                                    <span>{{$t('pt400.labels.gyosyu')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="gyosyu" class="gyosyu">{{pt406Request.analysisNm10}}</span>
                            </div>
                        </div>
                        <!--お名前-->
                        <div class="nameLine" >
                            <div class="label">
                                <label :class="pt406Init.nameEditFlg == 0?'required':''">
                                    <span>{{$t('pt400.labels.names'+common.stringNvl(pt406Init.siteKbn))}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <label v-if="pt406Init.name2Flg == 1" for="nm1" id="nm1_lbl">{{$t('pt400.labels.surname'+common.stringNvl(pt406Init.siteKbn))}}</label>
                                <label v-else for="nm" id="nm_lbl">{{$t('pt400.labels.name1')}}</label>
                                <span id="nm1" class="nm1">{{pt406Request.nm1}}</span>
                                <template v-if="pt406Init.name2Flg == 1">
                                    <!--名 名前２利用フラグが利用の場合-->
                                    <label for="nm2" id="nm2_lbl">{{$t('pt400.labels.name2'+common.stringNvl(pt406Init.siteKbn))}}</label>
                                    <span id="nm2" class="nm2">{{pt406Request.nm2}}</span>
                                </template>

                                <template v-if="!checkUnico(0)">
                                    <!--名 名前3-->
                                    <label v-if="pt406Init.siteKbn == 'B'" for="nm3" id="nm3_lbl">{{$t('pt400.labels.name3'+common.stringNvl(pt406Init.siteKbn))}}</label>
                                    <template v-if="pt406Init.siteKbn == 'B'">
                                        <span id="nm3" class="nm3">{{pt406Request.nm3}}</span>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!--カナ-->
                        <div class="kanaLine">
                            <div class="label">
                                <label :class="pt406Init.kanaHissuFlg == 0 && pt406Init.nameEditFlg == 0?'optional':pt406Init.nameEditFlg == 0?'required':''">
                                    <span>{{$t('pt400.labels.name'+common.stringNvl(pt406Init.siteKbn))}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <label v-if="pt406Init.name2Flg == 1" for="kana1">{{$t('pt400.labels.surname'+common.stringNvl(pt406Init.siteKbn))}}</label>
                                <label v-else for="kana">{{$t('pt400.labels.name1')}}</label>
                                <span id="kana1_lbl" hidden>{{$t('pt400.labels.nameSurnameKana'+common.stringNvl(pt406Init.siteKbn))}}</span>
                                <span id="kana_lbl" hidden>{{$t('pt400.labels.name')}}</span>
                                <span id="kana1" class="kana1">{{pt406Request.kana1}}</span>
                                <template v-if="pt406Init.name2Flg == 1">
                                    <!--名 名前２利用フラグが利用の場合-->
                                    <label for="kana2">{{$t('pt400.labels.name2'+common.stringNvl(pt406Init.siteKbn))}}<span v-if="pt406Init.siteKbn == 'B' && pt406Init.nameEditFlg == 0 && pt406Init.kanaHissuFlg == 1" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                    <span id="kana2" class="kana2">{{pt406Request.kana2}}</span>
                                </template>
                                <template v-if="!checkUnico(0)">
                                    <template v-if="pt406Init.siteKbn == 'B'">
                                        <!--名 名前3-->
                                        <label for="kana3">{{$t('pt400.labels.name3'+common.stringNvl(pt406Init.siteKbn))}}<span v-if="pt406Init.nameEditFlg == 0 && pt406Init.kanaHissuFlg == 1" class="optionalInfo ml-2">{{$t('common.labels.optional')}}</span></label>
                                        <span id="kana3_lbl" hidden>{{$t('pt400.labels.name3KanaB')}}</span>
                                        <span id="kana3" class="kana3">{{pt406Request.kana3}}</span>
                                    </template>
                                </template>
                            </div>
                        </div>
                        <!--郵便番号-->
                        <div class="zipLine">
                            <div class="label">
                                <label class="required" id="zip_lbl">
                                    <span>{{$t('common.labels.postalCode')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="zip" class="zip">{{pt406Request.zip}}</span>
                            </div>
                        </div>
                        <!--都道府県 プルダウン設定オプション-->
                        <div class="kenLine" v-if="pt406Init.kenPulldownDispFlg == 1">
                            <div class="label">
                                <label class="required" id="kenCd_lbl">
                                    <span>{{$t('common.labels.prefectures')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="kenNm" class="kenNm">{{pt406Request.kenNm}}</span>
                            </div>
                        </div>
                        <!--住所1 -->
                        <div class="addr1Line">
                            <div class="label">
                                <label class="required" id="addr1_lbl">
                                    <span>{{$t('pt400.labels.city')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="addr1" class="addr1">{{pt406Request.addr1}}</span>
                            </div>
                        </div>
                        <!--住所2 利用オプション-->
                        <div class="addr2Line" v-if="pt406Init.addr2Flg == 1">
                            <div class="label">
                                <label :class="pt406Init.addr2HissuFlg == 1?'required':'optional'" id="addr2_lbl" >
                                    <span>{{$t('pt400.labels.lessAddress')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="addr2" class="addr2">{{pt406Request.addr2}}</span>
                            </div>
                        </div>
                        <!--住所3 利用オプション-->
                        <div class="addr3Line" v-if="pt406Init.addr3Flg == 1">
                            <div class="label">
                                <label :class="pt406Init.addr3HissuFlg == 1?'required':'optional'" id="addr3_lbl" >
                                    <span>{{$t('common.labels.optionLabel')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="addr3" class="addr3">{{pt406Request.addr3}}</span>
                            </div>
                        </div>
                        <!--電話番号 -->
                        <div class="telLine">
                            <div class="label">
                                <label class="required" id="tel1_lbl">
                                    <span>{{$t('pt400.labels.phoneNumber')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="tel1" class="tel1">{{pt406Request.tel1}}</span>
                            </div>
                        </div>
                        <!--FAX -->
                        <div class="faxLine">
                            <div class="label">
                                <label class="optional" id="fax_lbl">
                                    <span>{{$t('common.labels.fax')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="fax" class="fax">{{pt406Request.fax}}</span>
                            </div>
                        </div>
                        <!-- 担当者情報1~3 ユニコカスタマイズ項目 -->
                        <template v-for="i in 3">
                            <div class="tantoushaLine" v-if="checkUnico(0)"  :key="i">
                                <div class="label">
                                    <label v-if="i == 1" class="required" :id="'unicoTantousha'+i+'_lbl'">
                                        <span>{{$t('pt400.labels.tantousha')+i}}</span>
                                    </label>
                                    <label v-else :class="pageType == PAGE_INSERT?'optional':'verticalAlignTop'" :id="'unicoTantousha'+i+'_lbl'">
                                        <span>{{$t('pt400.labels.tantousha')+i}}</span>
                                    </label>
                                </div>
                                <div class="input">
                                    <!-- 担当者名 -->
                                    <label :for="'unicoTantousha'+i+'_disp_lbl'" :id="'unicoTantoushaNm'+i+'_disp_lbl'">{{$t('pt400.labels.name3B')}}</label>
                                    <span :id="'unicoTantoushaNm'+i" :class="'unicoTantoushaNm'+i">{{pt406Request[`unicoTantoNm${i}`]}}</span>
                                    <!-- 担当者名カナ -->
                                    <label :for="'unicoTantoushaKana'+i+'_disp_lbl'" :id="'unicoTantoushaKana'+i+'_disp_lbl'">{{$t('pt400.labels.name3KanaB')}}</label>
                                    <span :id="'unicoTantoushaNm'+i" :class="'unicoTantoushaNm'+i">{{pt406Request[`unicoTantoKana${i}`]}}</span>
                                    <!-- 担当者電話番号 -->
                                    <label :for="'unicoTantoushaTel'+i+'_disp_lbl'" :id="'unicoTantoushaTel'+i+'_disp_lbl'">{{$t('pt400.labels.tantoushaTel')}}</label>
                                    <span :id="'unicoTantoushaNm'+i" :class="'unicoTantoushaNm'+i">{{pt406Request[`unicoTantoTel${i}`]}}</span>
                                </div>
                            </div>
                        </template>
                        <!--支払方法-->
                        <div class="kessaiNameLine" v-if="pt406Init.siteFlg == 1 && pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE == 1">
                            <div class="label">
                                <label class="optional" id="kessaiCd_lbl">
                                    <span>{{$t('pt400.labels.kessaiName')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="kessaiCd" class="kessaiCd">{{pt406Request.kessaiNm}}</span>
                            </div>
                        </div>
                        <!-- 生年月日-->
                        <div class="birthLine" v-if="pt406Init.siteKbn != 'B' && pt406Init.btobFlg == 0">
                            <div class="label" >
                                <label :class="pt406Init.birthdayUpdateFlg == 0?'optional':''" id="birthDay_lbl">
                                    <span>{{$t('common.labels.birthday')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <template v-if="pt406Init.birthdayUpdateFlg == 0">
                                    <input-check type="text" id="birthDayYYYY" class="birthYearInput numcode" @on-input-change="change()" name="birthDay_YYYY" maxlength="4" size="7" v-model="pt406Request.birthDayYYYY" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>
                                    <span class="birthYear">{{$t('common.labels.year')}}</span>
                                    <select v-model="pt406Request.birthDayMM" name="birthDay_MM" class="birthMonthSelect" @change="change()" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <option></option>
                                        <template v-for="mm in 12" >
                                            <option v-if="mm < 10" :key="mm" :value="'0'+mm">{{'0'+mm}}</option>
                                            <option v-else :key="mm" :value="mm">{{mm}}</option>
                                        </template>
                                    </select>
                                    <span class="birthMonth">{{$t('common.labels.month')}}</span>
                                    <select v-model="pt406Request.birthDayDD" name="birthDay_DD" class="birthDaySelect" @change="change()" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <option></option>
                                        <template v-for="dd in 31" >
                                            <option v-if="dd < 10" :key="dd" :value="'0'+dd">{{'0'+dd}}</option>
                                            <option v-else :key="dd" :value="dd">{{dd}}</option>
                                        </template>
                                    </select>
                                    <span class="birthDay">{{$t('common.labels.day')}}</span>
                                    <!--項目説明マスタ[28]-->
                                    <div v-html="pt406Init.descriptionInfo['17']"></div>
                                </template>
                                <template v-else>
                                    {{pt406Request.birthDayYYYY}}年
                                    {{pt406Request.birthDayMM}}月
                                    {{pt406Request.birthDayDD}}日
                                </template>
                            </div>
                        </div>
                        <!--性別-->
                        <div class="sexLine" v-if="pt406Init.siteKbn != 'B' && pt406Init.btobFlg == 0">
                            <div class="label">
                                <label :class="pt406Init.sexUpdateFlg == 0?'optional':''" id="sexKbn_lbl">
                                    <span>{{$t('common.labels.sex')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <template v-if="pt406Init.sexUpdateFlg == 0">
                                    <div class="sexKbn">
                                        <input type="radio" class="sexKbn1Input" name="sexKbn" @change="change()" value="1" v-model="pt406Request.sexKbn" id="sexKbn_0" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_0">{{$t('common.labels.male')}}</label>
                                        <input type="radio" class="sexKbn2Input" name="sexKbn" @change="change()" value="2" v-model="pt406Request.sexKbn" id="sexKbn_1" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_1">{{$t('common.labels.female')}}</label>
                                        <input type="radio" class="sexKbn3Input" name="sexKbn" @change="change()" value="9" v-model="pt406Request.sexKbn" id="sexKbn_2" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false">
                                        <label for="sexKbn_2">{{$t('common.labels.unspecified')}}</label>
                                        <!--項目説明マスタ[18]-->
                                        <div v-html="pt406Init.descriptionInfo['18']"></div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-if="pt406Request.sexKbn =='1'">{{$t('common.labels.male')}}</div>
                                    <div v-else-if="pt406Request.sexKbn =='2'">{{$t('common.labels.female')}}</div>
                                    <div v-else >{{$t('common.labels.unspecified')}}</div>
                                </template>
                            </div>
                        </div>
                        <!--メルマガ-->
                        <div class="mailMgLine" v-if="pt406Init.mailMgDispFlg == 1">
                            <div class="label">
                                <label class="required" id="mailMg_lbl">
                                    <span>{{$t('pt400.labels.emailMagazine')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt406Request.newsMailRcvFlg == 0" id="newsMailRcvFlg_0" class="newsMailRcvFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                                <span v-if="pt406Request.newsMailRcvFlg == 1" id="newsMailRcvFlg_1" class="newsMailRcvFlg_1">{{$t('pt400.labels.toWish')}}</span>
                            </div>
                        </div>
                        <!--DM-->
                        <div class="dmNgFlgLine" v-if="pt406Init.mailMgDispFlg == 1">
                        <div class="label">
                            <label class="required" id="dmNgFlg_lbl">
                            <span>{{$t('pt400.labels.dmNgFlg')}}</span>
                            </label>
                        </div>
                        <div class="input">
                            <span v-if="pt406Request.dmFlg == 0" id="dmNoFlg_0" class="dmNoFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                            <span v-if="pt406Request.dmFlg == 1" id="dmNoFlg_1" class="dmNoFlg_1">{{$t('pt400.labels.toWish')}}</span>
                        </div>
                        </div>
                        <!-- チラシ -->
                        <div class="flierNgFlgLine" v-if="pt406Init.flierNgFlg == 1">
                            <div class="label">
                                <label class="required" id="flierNgFlg_lbl">
                                    <span>{{$t('pt400.labels.flierNgFlg')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt406Request.flierNgFlg == 0" id="flierNgFlg_0" class="flierNgFlg_0">{{$t('pt400.labels.doNotWant')}}</span>
                                <span v-if="pt406Request.flierNgFlg == 1" id="flierNgFlg_1" class="flierNgFlg_1">{{$t('pt400.labels.toWish')}}</span>
                            </div>
                        </div>
                        <!--ニックネーム -->
                        <div class="nicknameLine" v-if="pt406Init.siteKbn != 'B' && !(pt406Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="nickname_lbl">
                                    <span>{{$t('pt400.labels.nickname')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="nickname" class="nickname">{{pt406Request.nickname}}</span>
                            </div>
                        </div>
                        <!--年齢 -->
                        <div class="ageLine" v-if="pt406Init.siteKbn != 'B' && !(pt406Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="age_lbl">
                                    <span>{{$t('pt400.labels.age')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt406Request.flierNgFlg == 0" id="age_Koukai_0" class="age_Koukai_0">{{$t('pt400.labels.koukai2')}}</span>
                                <span v-if="pt406Request.flierNgFlg == 1" id="age_Koukai_1" class="age_Koukai_1">{{$t('pt400.labels.koukai1')}}</span>
                            </div>
                        </div>
                        <!--性別 -->
                        <div class="sexDispLine" v-if="pt406Init.siteKbn != 'B' && !(pt406Init.entetsuFlg == 1 && pageType == PAGE_INSERT)">
                            <div class="label">
                                <label class="optional" id="sexDisp_lbl">
                                    <span>{{$t('common.labels.sex')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt406Request.flierNgFlg == 0" id="sex_Koukai_0" class="sex_Koukai_0">{{$t('pt400.labels.koukai2')}}</span>
                                <span v-if="pt406Request.flierNgFlg == 1" id="sex_Koukai_1" class="sex_Koukai_1">{{$t('pt400.labels.koukai1')}}</span>
                            </div>
                        </div>
                        <!--顧客グループ-->
                        <div class="kenLine" v-if="pt406Init.customerGroupFlg == 1 && pt406Init.siteKbn == 'B'">
                            <div class="label">
                                <label class="required" id="customerGroup_lbl">
                                    <span>{{pt406Init.analysisTitle}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <select v-model="pt406Request.customerGroup" @change="change()"  class="customerGroup"  id="customerGroup" name="customerGroup" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="cusGroup in pt406Init.customerGroupList" :key="cusGroup.KEY" :value="cusGroup.KEY">{{cusGroup.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <div class ="companyline" v-if="pt406Init.companyNmFlg == 1">
                            <!--会社名-->
                            <div class="label">
                                <label class="required" id="companyNm_lbl">
                                    <span>{{pt406Init.analysisTitle2}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <select v-model="pt406Request.companyNm" @change="change()"  class="companyNm"  id="companyNm" name="companyNm" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"> 
                                    <option v-for="companyNm in pt406Init.companyList" :key="companyNm.KEY" :value="companyNm.KEY">{{companyNm.VALUE}}</option>
                                </select>
                            </div>
                        </div>
                        <div class ="busyoNm" v-if="pt406Init.companyNmFlg == 1">
                            <div class="label">
                                <label class="required" id="busyoNm_lbl">
                                    <span>{{$t('pt400.labels.busyoNm')}}</span>
                                </label>
                            </div>
                            <!--部署名・協力会社-->
                            <div class="input">
                                <input-check type="text" id="busyoNm" class="busyoNm" @on-input-change="change()" name="busyoNm" maxlength="40" size="18" v-model="pt406Request.busyoNm" :disabled="pt406Init.passwordAndKessaiOption == 1 && pageType == PAGE_UPDATE ? true : false"/>       
                            </div>
                        </div>
                        <!-- 定休日 ユニコカスタマイズ項目 -->
                        <div class="teikyubiLine" v-if="checkUnico(1)">
                            <div class="label">
                                <label class="required" id="teikyubi_lbl">
                                    <span>{{$t('pt400.labels.teikyubi')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="teikyubi" class="teikyubi">{{pt406Request.yobiStr6}}</span>
                            </div>
                        </div>
                        <!-- 営業時間 ユニコカスタマイズ項目 -->
                        <div class="eigyojikan" v-if="checkUnico(1)">
                            <div class="label">
                                <label class="required" id="eigyojikan_lbl">
                                    <span>{{$t('pt400.labels.eigyojikan')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span id="eigyojikan" class="eigyojikan">{{pt406Request.unicoEigyojikanFrom}} ～ {{pt406Request.unicoEigyojikanTo}}</span>
                            </div>
                        </div>
                        <!-- シェフマル段ボール ユニコカスタマイズ項目 -->
                        <div class="reuseBox" v-if="checkUnico(0)">
                            <div class="label">
                                <label class="required" id="reuseBox_lbl">
                                    <span>{{$t('pt400.labels.reuseBox')}}</span>
                                </label>
                            </div>
                            <div class="input">
                                <span v-if="pt406Request.unicoReuseBox == 0" id="reuseBox_0" class="reuseBox_0">{{$t('pt400.labels.radioNg')}}</span>
                                <span v-if="pt406Request.unicoReuseBox == 1" id="reuseBox_1" class="reuseBox_1">{{$t('pt400.labels.radioOk')}}</span>
                            </div>
                        </div>
                    </div>

                    <!--新規登録かつ直接登録ではなく仮顧客マスタに登録する設定の場合-->
                    <p class="syoninMessage" v-if="pageType == PAGE_INSERT && pt406Init.syouninOption == 1">
                        <span class="center" v-html="pt406Init.descriptionInfo['53']"></span>
                    </p>
                    <!--戻るボタン-->
                    <div id="btn_roll3">
                        <a class="btnCancel" @click="backUrl(8)">{{$t('common.buttons.return')}}</a>
                    </div>
                    <!--登録ボタン-->
                    <div id="btn_roll2" v-if="pageType == PAGE_INSERT">
                        <a class="btnSubmit" @click="confirmDoInsert()">{{$t('common.buttons.signup')}}</a>
                    </div>
                    <!--更新ボタン-->
                    <div id="btn_roll2" v-if="pageType == PAGE_UPDATE">
                        <a class="btnSubmit" @click="confirmDoUpdate()">{{$t('common.buttons.update')}}</a>
                    </div>
                </template>

                </template>
            </div><!--/ .section-inner -->
            <!-- modal confirm area -->
            <!--アラート表示-->
            <alert-confirm
                v-if="isModalShow"
                :msgConfirm="msgConfirm"
                :okAction="doAction"
                :isButtonCancel="isButtonCancel">
            </alert-confirm>
            <CC212InputPostal v-if="cc212Dislay" @modal-close="cc212Dislay = false" :propTdkZip1="dataCc212.propTdkZip1" 
            :propTdkZip2="dataCc212.propTdkZip2" :propIdx="dataCc212.propIdx" @set-addr-value="setAddrValue" />
        </div>
    </div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import common from 'assets/js/common';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import CC212InputPostal from '../search/CC212InputPostal';

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    /*
    * Name of component
    */
    name: "PT406MemberInfoCheckParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
        ptInitCommonData: {
            type: Object,
            default: null,
        },
    },
    /*
    * Declare components
    */
    components: {
        Message: Message,
        Loading,
        InputCheck,
        AlertConfirm,
        Breadcrumb,
        toastr,
        CC212InputPostal
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            PT406_PART: 'pt406',
            common:common,
            isLoading: false,
            isDisplay: false,
            pt406Init: {
                orderInfo:{},
                realAuthoriFlg: 1,
                descriptionInfo:{},
                backButtonFlg: 0,
                entetsuFlg: 0,
                entetsuKohojinFlg: 0
            },
            pt406Request: {
                agreeFlag:0,
                //zip:null,
                zip1:null,
                zip2:null,
                //addr1:null,
                //addr2:null,
                //addr3:null,

                mail: null,
                mailOld: null,
                mail_confirm: null,
                password: null,
                passwordSub: null,
                prePassword: null,
                nm1: null,
                nm2: null,
                kana1: null,
                kana2: null,
                birthDayYYYY: null,
                birthDayMM: null,
                birthDayDD: null,
                sexKbn: null,
                zip: null,
                kenCd: null,
                addr1: null,
                addr2: null,
                addr3: null,
                tel1: null,
                tel2: null,
                fax: null,
                newsMailRcvFlg: null,
                kokyakuRankKbn: null,
                kokyakuRankKbnNm: null,
                pointNum: null,
                exclCnt: null,
                nickname: null,
                ageOpenFlg: null,
                sexOpenFlg: null,
                kaiinCheck: null,
                authUuid: null,
                ikoPassword: null,
                ikoPasswordSub: null,
            },
            isButtonCancel: true,
            actionFlg:0,
            koumokuList:'',
            zeiKbnNm:'',
            isModalShow:false,
            listIdErr:[],
            SiteConstants: SiteConstants,
            PAGE_INSERT:'3',
            PAGE_UPDATE:'4',
            tdkNum:4,
            pageType:3,
            isModalShow:false,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            isButtonOK:false,
            cc212Dislay:false,
            dataCc212: {},
            cc212ReqModel:{},
            tdkIndex:null,
            site: "",
            mailMessage1:"",
            mailMessage2:"",
            isUpdateFlg: false,
            report: "",
            isAddr23Flg: false,
            isMailAuthSendFlg: false,
            isMailAuthErr: false,

            unicoCognitionDtlFlg: false,
            unicoCognitionDtlInfo1: "",
            unicoCognitionDtlInfo2: "",
            unicoTeikyubiList: ['月', '火', '水', '木', '金', '土', '日', '不定休', '祝', 'なし'],
            unicoTeikyubi: [],
            unicoEigyojikanHH: [],
            unicoEigyojikanMI: [],
            unicoEigyojikanFromHH: "00",
            unicoEigyojikanFromMI: "00",
            unicoEigyojikanToHH: "00",
            unicoEigyojikanToMI: "00",
            pt406params: {},
            ikoPasswordDispFlg: 0,
            isErrorFlg: 0,
            pt400ExclCnt: 1,
            passwordView: ""
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.pt400ExclCnt = _this.$route.params.exclCnt;
        _this.passwordView = _this.$route.params.passwordView;
        axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_INIT,_this.pt406Request).then(function(response) {
            _this.pt406Init = response.data;
            _this.pt406Request = Object.assign({}, _this.pt406Request, response.data.reqModel);

            // ログイン済の場合
            if(_this.pt406Init.isLogin == true){
                _this.pageType = 4;
            }

            // 会員規約のセット
            var splInfo = _this.pt406Init.descriptionInfo['40'];
            if (splInfo != null && splInfo.length > 0) {
                splInfo = splInfo.split('\n');
                var des40 = '';
                for(var i = 0; i < splInfo.length; i++){
                    des40 = des40.concat(splInfo[i] + '<br>');
                }
                _this.pt406Init.descriptionInfo['40'] = des40;
            }
            // エラー情報がある場合
            if(response.data.errList != null && response.data.errList.length > 0){
                _this.displayWarning(response.data.errList);
            }
            // メールに関する注意事項１
            if(_this.pt406Init.descriptionInfo[2] != undefined){
                _this.mailMessage1 = _this.pt406Init.descriptionInfo[2];
                _this.mailMessage1 = _this.mailMessage1.replace("{0}",_this.pt406Init.siteMail)
            }
            // メールに関する注意事項２
            if(_this.pt406Init.descriptionInfo[3] != undefined){
                _this.mailMessage2 = _this.pt406Init.descriptionInfo[3];
                _this.mailMessage2 = _this.mailMessage2.replace("{0}",_this.pt406Init.siteMail)
            }

            if (_this.pt406Init.entetsuKohojinFlg == 1 && _this.pageType == _this.PAGE_INSERT){
                if (common.isNullItem(_this.pt406params.cardKaiinFlg)){
                    if (sessionStorage.getItem('kaiin')){
                        _this.pt406params = Object.assign({}, JSON.parse(sessionStorage.getItem('kaiin')));
                    }
                }
                sessionStorage.removeItem('kaiin');

                if (_this.pt406params.cardKaiinFlg  != null && _this.pt406params.cardKaiinFlg !== ''){
                    if (_this.pt406params.kenCd){
                        const found = _this.pt406Init.kenCdList.find(item => item.VALUE === _this.pt406params.kenCd);
                        _this.pt406params.kenCd = found ? found.KEY : null;
                    }
                    _this.pt406Request = Object.assign({}, _this.pt406Request, _this.pt406params);
                    if (_this.pt406params.existsFlg == 0){
                        _this.ikoPasswordDispFlg = 1;
                    }else{
                        _this.ikoPasswordDispFlg = 0;
                    }
                }

                //遠鉄 cookie存在チェック
                if (_this.entetsuCookieCheck()){
                    console.log("cookieがないです!!!");
                }
            }
        }).catch(function(error) {
            common.errorAPI(error);
        });

        for (var i=0; i<_this.unicoTeikyubiList.length; i++){
            _this.unicoTeikyubi.push(false);
        }
        for (var i=0; i<24; i++){
            var hh = ('0' + i).slice(-2);
            _this.unicoEigyojikanHH.push({KEY: hh, VALUE: hh});
        }
        for (var i=0; i<60; i++){
            var mi = ('0' + i).slice(-2);
            _this.unicoEigyojikanMI.push({KEY: mi, VALUE: mi});
        }

        //POPUPを閉じるイベント
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
            _this.isAddr23Flg = false;
        });
    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
        */
        getAddr23Msg: function(){
            let msg = "";
            if ((this.pt406Init.addr2Flg == 1 && this.pt406Init.addr2HissuFlg == 2 && this.pt406Request.addr2 == "") || 
                (this.pt406Init.addr3Flg == 1 && this.pt406Init.addr3HissuFlg == 2 && this.pt406Request.addr3 == "")) {

                let subMsg2 = this.$i18n.t('pt400.labels.lessAddress');
                let subMsg3 = this.$i18n.t('common.labels.optionLabel');

                if ((this.pt406Init.addr2Flg == 1 && this.pt406Init.addr2HissuFlg == 2 && this.pt406Request.addr2 == "") &&  
                    (this.pt406Init.addr3Flg == 1 && this.pt406Init.addr3HissuFlg == 2 && this.pt406Request.addr3 == "")){
                    msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2 + "と" + subMsg3);
                }else{
                    if (this.pt406Init.addr2Flg == 1 && this.pt406Init.addr2HissuFlg == 2 && this.pt406Request.addr2 == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg2);
                    }
                    if (this.pt406Init.addr3Flg == 1 && this.pt406Init.addr3HissuFlg == 2 && this.pt406Request.addr3 == ""){
                        msg = this.$i18n.t('pt400.labels.messg7').replace("{0}", subMsg3);
                    }
                }
            }
            return msg;
        },
        /*
        * 登録ボタン押下処理（メールアドレス認証）
        */
        confirmDoAuth: function(){
            this.msgConfirm = this.$i18n.t('pt400.labels.messg8')
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 5;
        },
        /*
        * 登録ボタン押下処理
        */
        confirmDoInsert: function(){
            
            //遠鉄 cookie存在チェック
            if (this.entetsuCookieCheck()){
                console.log("cookieがないです!!!");
                return;
            }
            
            if (this.isAddr23Flg){
                this.isAddr23Flg = false;
                this.$nextTick(() => {
                    this.isAddr23Flg = false;
                    this.msgConfirm = this.$i18n.t('pt400.labels.messg2');
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 1;
                });
            }else{
                this.msgConfirm = this.$i18n.t('pt400.labels.messg2')
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 1;
            }
        },
        /*
        * 認証メール送信処理
        */
        doMailAuth: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt406_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_CONFIRM, _this.pt406Request).then(function(response) {
                if(response.data.status == 'OK'){
                    // 認証メール送信完了にする
                    _this.isMailAuthSendFlg = true;
                }
                // エラーがあった場合
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt406_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * メールアドレス認証確認処理
        */
        checkMailAuth: function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_AJAX, _this.pt406Request).then(function(response) {
                if(response.data.status == 'OK'){
                    // 認証OKにする
                    _this.isMailAuthErr = false;
                    if (response.data.response.mailAddr) {
                        // メールアドレスを認証したもので固定する。
                        _this.pt406Request.mail = response.data.response.mailAddr;
                    }
                } else {
                    // 認証エラーにする
                    _this.isMailAuthErr = true;
                }
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt406_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        *  登録処理
        */
        doInsert: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt406_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_INSERT, _this.pt406Request).then(function(response) {
                var fromCart = _this.pt406Request.fromCart != null? _this.pt406Request.fromCart:'';
                if(response.data.status == 'OK'){
                    sessionStorage.setItem('pt406Request', JSON.stringify(_this.pt406Request));
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 12, fromCart:fromCart}});
                }
                // エラーがあった場合
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt406_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /*
        * 更新ボタン押下処理
        */
        confirmDoUpdate: function(){
            // 住所２/住所３が利用するそして必須チェック利用が確認する時でメッセージを戻る
            let msg = this.getAddr23Msg();
            if (msg != "" && !this.isAddr23Flg){
                this.msgConfirm = msg;
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 4;
                this.isAddr23Flg = true;
                return;
            }
            
            if (this.isAddr23Flg){
                this.isAddr23Flg = false;
                this.$nextTick(() => {
                    this.isAddr23Flg = false;
                    this.msgConfirm = this.$i18n.t('pt400.labels.messg3')
                    this.isModalShow = true;
                    this.isButtonCancel = true;
                    this.actionFlg = 2;
                });
            }else{
                this.msgConfirm = this.$i18n.t('pt400.labels.messg3')
                this.isModalShow = true;
                this.isButtonCancel = true;
                this.actionFlg = 2;
            }
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function(page) {
            var _this = this;
            // 指定された画面へ遷移
            // 新規会員登録・更新いずれの場合もデータを引き継ぐ
                sessionStorage.setItem('pt406Request', JSON.stringify(_this.pt406Request));
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: page, pt406backFlg: true}});
        },
        /*
        *  更新処理
        */
        doUpdate: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            var report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt406_PART);
            var tdkList = _this.pt406Request.tdkList;
            let req = Object.assign({}, _this.pt406Request, { exclCnt: _this.pt400ExclCnt });
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_UPDATE, req).then(function(response) {
                if(response.data.status == 'OK'){
                    if(response.data.response != null){
                        // 更新完了メッセージ
                        report = response.data.response.message;
                        toastr.success(report);
                        
                        _this.pt406Request.exclCnt = response.data.response.exclCnt;
                        _this.pt406Request.mailOld = response.data.response.mailOld;
                        // マイメニュー画面へ遷移
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
                    }
                }
                // エラー表示
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt406_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 入力項目を変更した場合更新ボタンをアクティブにする
        */
        change: function() {
            var _this = this;
            _this.isUpdateFlg = true;
        },
        /*
        * チェックが付いたら重複チェックを行う
        */
        check: function() {
            var _this = this;
            _this.$emit("event-loading", true);
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt406_PART);
            if(_this.pt406Request.kokyakuCd == null || _this.pt406Request.kokyakuCd == undefined || _this.pt406Request.kokyakuCd == ''){
                _this.pt406Request.kaiinCheck = 2;
                _this.$emit("event-loading", !true);
            } else {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT406 + _this.$UrlConstants.DO_CHECK, _this.pt406Request).then(function(response) {
                    _this.pt406Request.kaiinCheck = response.data;
                    // エラーがあった場合
                    if(response.data.errList != null && response.data.errList.length > 0){
                        _this.displayWaring(response.data.errList);
                    }
                    _this.$emit("event-loading", !true);
                }).catch(function(error) {
                    _this.$emit("event-loading", !true);
                    if(error != null && error != undefined){
                        if(error.response != null && error.response != undefined){
                            if(406 == error.response.status){
                                var resultValid = common.excuteValidationEcSite(error, _this.pt406_PART);
                                if(resultValid){
                                    _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                    _this.listMessValid = resultValid.msgList;
                                    _this.mapMessValid = resultValid.mapMsg;
                                    _this.pt406Request.kaiinCheck = 1;
                                }
                                common.scrollTop();
                            }else{
                                common.errorAPI(error);
                            }
                        }
                    }
                });
            }
        },
         /*
        *  POPUP表示処理 actionFlg
        * 1: 登録処理
        * 2: 更新処理
        */
        doAction: function(){
            var _this = this;
            switch (_this.actionFlg) {
                case 1:
                    _this.doInsert();
                    break;
                case 2:
                    _this.doUpdate();
                    break;
                case 3:
                    _this.isAddr23Flg = true;
                    _this.confirmDoInsert();
                    break;
                case 4:
                    _this.isAddr23Flg = true;
                    _this.confirmDoUpdate();
                    break;
                case 5:
                    _this.doMailAuth();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }

                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                            
                        }
                    }
                }

                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        },
        /*
        * 住所検索処理
        */
        addrAutoInput: function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            var zip = _this.pt406Request.zip;

            if(_this.tdkIndex != 'kokyaku'){
                zip = _this.pt406Request.tdkList[tdkIndex].tdkZip;
            }

            // 空の場合
			if ( common.isNullItem(zip) ) {
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号は必須です。
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeIsMandatory');
				_this.isButtonCancel = true;
				_this.isButtonOK = false;
				return;
			}
			var zipArr = zip.split("-");
			var zip1 = "";
			var zip2 = "";
            // 7桁以上の場合
            if ( zip.length >= 7 ) {
                // ハイフンが含まれている場合
                if ( zip.includes("-") ) {
                    zip1 = zipArr[0];
                    zip2 = zipArr[1];
                    // 3桁-4桁でない場合はエラー
                    if (zip1.length != 3 && zip2.length != 4) {
                        _this.msgConfirm = _this.$t("sh030.labels.zipCodeDoesNotExist");
                        _this.isModalShow = true;
                        return;
                    }
                // ハイフンが含まれていない場合
                } else {
                    zip1 = zip.substring(0,3);
                    zip2 = zip.substring(3,7);
                
                    _this.pt406Request.zip = zip1 + "-" + zip2;
                }
            } else {
                return;
            }
			
			_this.cc212ReqModel.tdkZip1 = zip1;
			_this.cc212ReqModel.tdkZip2 = zip2;
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.POPUP + _this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, _this.cc212ReqModel).then(function(response) {
				if (response.data.allAddr == 'juufuku'){
					_this.dataCc212.propTdkZip1 = zip1;
					_this.dataCc212.propTdkZip2 = zip2;
					_this.cc212Dislay = true;
				}
				else {
					_this.setAddr(response.data.allAddr ,response.data.kenCd,response.data.kenNm, zip1 ,zip2,tdkIndex);
				}
				_this.$emit("event-loading", !true);
			}).catch(function(error) {
				_this.$emit("event-loading", !true);
				common.errorAPI(error);
			});
		},
		// 住所検索Ajaxの戻り
		// パラメータの_addrに「住所,町名番地,建物名・部屋番号」の形で戻ってくる(30文字ずつ)
		setAddr: function (addr, kenCd , kenNm, zip1 , zip2, tdkIndex){
            var _this = this;
            var sp = new Array("","","");
			if (addr) {
                sp = addr.split(",");
                var displayAddr = sp[0]==null?'':sp[0] ;
                displayAddr += sp[1]==null?'':sp[1];
                displayAddr += sp[2]==null?'':sp[2];

                if(_this.tdkIndex == 'kokyaku'){
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt406Init.kenPulldownDispFlg == 0){
                        _this.pt406Request.addr1 = kenNm + displayAddr;
                    }else{
                        _this.pt406Request.addr1 = displayAddr;
                    }
                    _this.pt406Request.kenCd = kenCd;
                    _this.pt406Request.zip = zip1+ "-" +zip2;
                } else{
                    //都道府県のプルダウンを使用しない場合
                    if(_this.pt406Init.kenPulldownDispFlg == 0){
                        _this.pt406Request.tdkList[_this.tdkIndex].tdkAddr1 = kenNm + displayAddr;
                    }else{
                        _this.pt406Request.tdkList[_this.tdkIndex].tdkAddr1 = displayAddr;
                    }
                    _this.pt406Request.tdkList[_this.tdkIndex].tdkKenCd = kenCd;
                    _this.pt406Request.tdkList[_this.tdkIndex].tdkZip = zip1+ "-" +zip2;
                }
				_this.$forceUpdate();
			}else{
				if (_this.isModalShow != true){
					_this.isModalShow = true;
				}
				// 郵便番号が存在しません
				_this.msgConfirm =_this.$i18n.t('sh030.labels.zipCodeDoesNotExist');
				_this.pt406Request.zip= '';
				_this.isButtonCancel=true;
				_this.isButtonOK=false;
			}
		},
        setAddrValue:function(data){
            var _this = this;
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd+"";
            //都道府県のプルダウンを使用しない場合
            if(_this.pt406Init.kenPulldownDispFlg == 0){
                _this.pt406Request.addr1 = addr1;
            }else{
                _this.pt406Request.addr1 = _this.outKenNm(kenCd,addr1);
            }
            _this.pt406Request.kenCd = kenCd;
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        /*
        * 都道府県名を削除
        */
        outKenNm :function(kenCd,addr) {
            var kenList = this.pt406Init.kenCdList;
            for ( var i = 0; kenList.length > i; i++) {
                if(kenList[i].KEY == kenCd) {
                    return  addr.replace(kenList[i].VALUE,"");
                }
            }
        },

        /*
        * ユニコカスタマイズ項目用チェック
        */
        checkUnico(insertOnlyFlg) {
            var _this = this;
            var res = false;
            if (_this.pt406Init.unicoCusFlg == 1) {
                if (insertOnlyFlg == 1) {
                    if (_this.pageType == _this.PAGE_INSERT) {
                        res = true;
                    }
                } else {
                    res = true;
                }
            }
            return res;
        },
        /*
        * ユニコカスタマイズ 知ったきっかけの入力欄チェック
        */
       unicoCognitionChg() {
            var _this = this;
            _this.unicoCognitionDtlFlg = false;
            _this.unicoCognitionDtlInfo1 = "";
            _this.unicoCognitionDtlInfo2 = "";
            _this.pt406Request.unicoCognitionDtlTitle1 = "";
            _this.pt406Request.unicoCognitionDtlTitle2 = "";
            _this.pt406Request.unicoCognitionDtlValue1 = "";
            _this.pt406Request.unicoCognitionDtlValue2 = "";
            // ユニコカスタマイズがON
            if (_this.checkUnico(0)) {
                // 選択されていて、「WEBサイト・ネットから検索」以外のとき表示
                if (_this.pt406Request.unicoCognition && _this.pt406Request.unicoCognition != '03' && _this.pt406Request.unicoCognition != '') {

                    switch (_this.pt406Request.unicoCognition) {
                        case '01':
                            _this.pt406Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionCatalogId');
                            _this.unicoCognitionDtlInfo1 = _this.$i18n.t('pt400.labels.cognitionCatalogIdInfo');
                            break;
                        case '02':
                            _this.pt406Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionMagazine');
                            break;
                        case '04':
                            _this.pt406Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionIntroduce1');
                            _this.pt406Request.unicoCognitionDtlTitle2 = _this.$i18n.t('pt400.labels.cognitionIntroduce2');
                            break;
                        case '05':
                            _this.pt406Request.unicoCognitionDtlTitle1 = _this.$i18n.t('pt400.labels.cognitionBeforeStore1');
                            _this.pt406Request.unicoCognitionDtlTitle2 = _this.$i18n.t('pt400.labels.cognitionBeforeStore2');
                            break;
                        default:
                            break;
                    }

                    _this.unicoCognitionDtlFlg = true;
                }
            }
       },

        /*
        * 遠鉄 cookie存在チェック
        */
        entetsuCookieCheck(){
            let result = false;

            if (this.pt406Init.entetsuKohojinFlg == 1 && common.isNullItem(this.pt406Request.kaiNo)){
                this.isErrorFlg = 1;

                this.listMessValid = [];
                this.mapMessValid = [];
                common.clearMessageEcSite(this.listIdErr, this.pt406_PART);
                this.listMessValid.push(this.$i18n.t('entetsu.messages.apiResultErrMsg'));
                common.scrollTop();
                result = true;
            }

            return result;
        }

    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    },
    /*
    * Excute code after an instance is created
    */
    created: function(){
         var _this = this;
        // Get data from params and query
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0){
            _this.pt406Request.authUuid = queryData.uuid;
        }
        let params = _this.$route.params;
        if (params){
            _this.pt406params = Object.assign({}, params);
        }
    }
}
</script>